import React, { createContext, useContext, useEffect, useState } from "react";

interface MaintenanceData {
  is_enabled?: boolean;
  message?: string;
  detail?: string;
  estimated_end_at?: string | null;
}

interface MaintenanceContextType {
  isMaintenance: boolean;
  maintenanceData: MaintenanceData | null;
  setMaintenanceMode: (data: MaintenanceData | null) => void;
}

const MaintenanceContext = createContext<MaintenanceContextType>({
  isMaintenance: false,
  maintenanceData: null,
  setMaintenanceMode: () => {},
});

export const useMaintenance = () => useContext(MaintenanceContext);

export const MaintenanceProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [maintenanceData, setMaintenanceData] = useState<MaintenanceData | null>(
    null
  );

  useEffect(() => {
    const handleMaintenanceEvent = (event: Event) => {
      const customEvent = event as CustomEvent;
      const data = customEvent.detail;
      setIsMaintenance(true);
      setMaintenanceData(data);
    };

    window.addEventListener("maintenance-mode", handleMaintenanceEvent);

    return () => {
      window.removeEventListener("maintenance-mode", handleMaintenanceEvent);
    };
  }, []);

  const setMaintenanceMode = (data: MaintenanceData | null) => {
    if (data) {
      setIsMaintenance(true);
      setMaintenanceData(data);
    } else {
      setIsMaintenance(false);
      setMaintenanceData(null);
    }
  };

  return (
    <MaintenanceContext.Provider
      value={{ isMaintenance, maintenanceData, setMaintenanceMode }}
    >
      {children}
    </MaintenanceContext.Provider>
  );
};
